// import apiClient from 'apiClient'
import { USER_GET_TOKEN_SUCCESS, USER_GET_TOKEN_FAIL, USER_LOGIN_REQUEST, USER_LOGIN_SUCCESS, USER_LOGIN_FAIL, MENTOR_REGISTER_REQUEST, MENTOR_REGISTER_SUCCESS, MENTOR_REGISTER_FAIL, STUDENT_REGISTER_REQUEST, STUDENT_REGISTER_SUCCESS, STUDENT_REGISTER_FAIL, USER_PROFILE_REQUEST, USER_PROFILE_FAIL, USER_PROFILE_SUCCESS, USER_PROFILE_UPDATE_FAIL, USER_PROFILE_UPDATE_SUCCESS, USER_PROFILE_UPDATE_REQUEST, USER_LOGOUT_REQUEST, USER_LOGOUT_SUCCESS, USER_LOGOUT_FAIL } from './user.constants'
import { enqueueSnackbar } from '../alert/alert.actions'
import { apiBaseURL } from '../../services/config'
import apiClient from '../../services/axios';


export const getToken = () => async (dispatch) => {
    let res
    try {
        if (apiBaseURL != null) {
            res = await apiClient.get(apiBaseURL + '/sanctum/csrf-cookie', { withCredentials: true });
        } else {
            await apiClient.get('/sanctum/csrf-cookie', { withCredentials: true });
        }

        console.log(res)

        dispatch({
            type: USER_GET_TOKEN_SUCCESS,
        })
    } catch (error) {
        dispatch({
            type: USER_GET_TOKEN_FAIL,
            payload: error.response && error.response.data.message ? error.response.data.message : error.message
        })
    }
}

export const login = (email, password) => async (dispatch) => {
    try {
        dispatch({
            type: USER_LOGIN_REQUEST
        })

        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        let resData

        if (apiBaseURL != null) {
            const { data } = await apiClient.post(apiBaseURL + '/login', { email, password }, config)
            resData = data
        } else {
            const { data } = await apiClient.post('/login', { email, password }, config)
            resData = data
        }


        if (resData.errors) {
            dispatch({
                type: USER_LOGIN_FAIL,
                payload: resData.errors
            })

            Object.values(resData.errors).forEach((error) => {
                dispatch(enqueueSnackbar({
                    message: error,
                    options: {
                        key: new Date().getTime() + Math.random(),
                        variant: 'error',
                    },
                }));
            });
        } else {
            dispatch({
                type: USER_LOGIN_SUCCESS,
                payload: resData
            })
            dispatch(enqueueSnackbar({
                message: 'Login Successful',
                options: {
                    key: new Date().getTime() + Math.random(),
                    variant: 'success',
                },
            }));
        }

    } catch (error) {
        dispatch({
            type: USER_LOGIN_FAIL,
            payload: error.response && error.response.data.message ? error.response.data.message : error.message
        })
        dispatch(enqueueSnackbar({
            message: error.response && error.response.data.message ? error.response.data.message : error.message,
            options: {
                key: new Date().getTime() + Math.random(),
                variant: 'error',
            },
        }));
    }
}

export const mentorRegister = (email, first_name, last_name, phone, occupation, description, password, password_confirmation) => async (dispatch) => {
    try {
        dispatch({
            type: MENTOR_REGISTER_REQUEST,
        });
        const config = {
            headers: {
                "content-Type": "application/json",
            },
        };

        let resData
        if (apiBaseURL != null) {
            const { data } = await apiClient.post(
                apiBaseURL + "/api/register-mentor",
                { email, first_name, last_name, phone, occupation, description, password, password_confirmation },
                config
            );
            resData = data
        } else {
            const { data } = await apiClient.post(
                "/api/register-mentor",
                { email, first_name, last_name, phone, occupation, description, password, password_confirmation },
                config
            );
            resData = data
        }


        dispatch({
            type: MENTOR_REGISTER_SUCCESS,
        });

        dispatch(enqueueSnackbar({
            message: 'Registration Successful',
            options: {
                key: new Date().getTime() + Math.random(),
                variant: 'success',
            },
        }));

    } catch (error) {
        console.log(error.response.data)
        dispatch({
            type: MENTOR_REGISTER_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });

        dispatch(enqueueSnackbar({
            message: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
            options: {
                key: new Date().getTime() + Math.random(),
                variant: 'error',
            },
        }));
    }
};


export const studentRegister = (email, first_name, last_name, phone, password, password_confirmation) => async (dispatch) => {
    try {
        dispatch({
            type: STUDENT_REGISTER_REQUEST,
        });

        const config = {
            headers: {
                "content-Type": "application/json",
            },
        };

        let resData
        if (apiBaseURL != null) {
            const { data } = await apiClient.post(
                apiBaseURL + "/api/register-student",
                { email, first_name, last_name, phone, password, password_confirmation },
                config
            );
            resData = data
        } else {
            const { data } = await apiClient.post(
                "/api/register-student",
                { email, first_name, last_name, phone, password, password_confirmation },
                config
            );
            resData = data
        }

        dispatch({
            type: STUDENT_REGISTER_SUCCESS,
        });

        dispatch(enqueueSnackbar({
            message: 'Registration Successful',
            options: {
                key: new Date().getTime() + Math.random(),
                variant: 'success',
            },
        }));

    } catch (error) {
        console.log(error.response.data)
        dispatch({
            type: STUDENT_REGISTER_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });

        dispatch(enqueueSnackbar({
            message: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
            options: {
                key: new Date().getTime() + Math.random(),
                variant: 'error',
            },
        }));
    }
};

export const getProfile = () => async (dispatch) => {
    try {
        dispatch({
            type: USER_PROFILE_REQUEST,
        });

        let resData

        if (apiBaseURL != null) {
            const { data: { data } } = await apiClient.get(apiBaseURL + "/api/profile");
            resData = data
        } else {
            const { data: { data } } = await apiClient.get("/api/profile");
            resData = data
        }


        dispatch({
            type: USER_PROFILE_SUCCESS,
            payload: resData
        });

        dispatch(enqueueSnackbar({
            message: 'Profile retrieved successfully',
            options: {
                key: new Date().getTime() + Math.random(),
                variant: 'success',
            },
        }));

    } catch (error) {
        console.log(error.response.data)
        dispatch({
            type: USER_PROFILE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });

        dispatch(enqueueSnackbar({
            message: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
            options: {
                key: new Date().getTime() + Math.random(),
                variant: 'error',
            },
        }));
    }
};

export const updateUserProfile = (user) => async (dispatch) => {
    try {
        dispatch({
            type: USER_PROFILE_UPDATE_REQUEST,
        });

        const config = {
            headers: {
                "content-Type": "application/json",
            },
        };

        let resData

        if (apiBaseURL != null) {
            const { data } = await apiClient.post(apiBaseURL + "/api/profile", user, config);
            resData = data
        } else {
            const { data } = await apiClient.post("/api/profile", user, config);
            resData = data
        }



        dispatch({
            type: USER_PROFILE_UPDATE_SUCCESS,
            payload: resData
        });

        dispatch(enqueueSnackbar({
            message: 'Profile Updated successfully',
            options: {
                key: new Date().getTime() + Math.random(),
                variant: 'success',
            },
        }));

    } catch (error) {
        console.log(error.response.data)
        dispatch({
            type: USER_PROFILE_UPDATE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });

        dispatch(enqueueSnackbar({
            message: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
            options: {
                key: new Date().getTime() + Math.random(),
                variant: 'error',
            },
        }));
    }
};
export const logout = () => async (dispatch) => {
    localStorage.removeItem('japaToken')
    try {
        dispatch({
            type: USER_LOGOUT_REQUEST,
        });

        const config = {
            headers: {
                "content-Type": "application/json",
            },
        };

        let resData

        if (apiBaseURL != null) {
            const { data: { message } } = await apiClient.post("/logout", {}, config);
            resData = message
        } else {
            const { data: { message } } = await apiClient.post("/logout", {}, config);
            resData = message
        }



        dispatch({
            type: USER_LOGOUT_SUCCESS,
        });

        dispatch(enqueueSnackbar({
            message: resData,
            options: {
                key: new Date().getTime() + Math.random(),
                variant: 'success',
            },
        }));

    } catch (error) {
        console.log(error.response.data)
        dispatch({
            type: USER_LOGOUT_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });

        dispatch(enqueueSnackbar({
            message: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
            options: {
                key: new Date().getTime() + Math.random(),
                variant: 'error',
            },
        }));
    }
};